/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/presentationList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_FEATURES } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IFeaturesMethods extends IPluginMethodMap {
  getFeatures(args: any): Promise<any>;
}

export class FeaturesService implements IAgentPlugin {
  readonly methods: IFeaturesMethods;

  constructor() {
    this.methods = {
      getFeatures: this.getFeaturesProps.bind(this),
    };
  }

  async getFeaturesProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("hifi->", args?.id);
    const filter: any = {};

    if (args?.presentation) {
      filter.presentation = {
        eq: args.presentation,
      };
    }

    if (args?.id) {
      filter.costumeType = {
        eq: args.id,
      };
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_FEATURES,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          return {
            searchStatusFilter: this.format(
              res?.data?.getCostumeFeatures?.content,
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
  private format(data: any) {
    return data.map((_item) => {
      return {
        label: _item?.name,
        value: _item?.id,
      };
    });
  }
}
